import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Image } from 'components';
import { media } from "utils/media";

const IconsWithText = ({ className, content }) => (
  <div className={cx('section-icons-aligner', [className])}>
    <h2 className='section-icons-title t-center mb-10' dangerouslySetInnerHTML={{ __html: content.title }} />
    <p className='t-center mb-40' dangerouslySetInnerHTML={{ __html: content.text }} />

    <div className='section-icons'>
      <div className='icon-wrapper'>
        <Image url={media(content.icon1)} alt={content.icon1Text} />
        <p><b dangerouslySetInnerHTML={{ __html: content.icon1Text }} /></p>
      </div>
      <div className='icon-wrapper'>
        <Image url={media(content.icon2)} alt={content.icon2Text} />
        <p><b dangerouslySetInnerHTML={{ __html: content.icon2Text }} /></p>
      </div>
      <div className='icon-wrapper'>
        <Image url={media(content.icon3)} alt={content.icon3Text} />
        <p><b dangerouslySetInnerHTML={{ __html: content.icon3Text }} /></p>
      </div>
      <div className='icon-wrapper'>
        <Image url={media(content.icon4)} alt={content.icon4Text} />
        <p><b dangerouslySetInnerHTML={{ __html: content.icon4Text }} /></p>
      </div>
    </div>
  </div>
);

IconsWithText.propTypes = {
  className: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired,
};

IconsWithText.defaultProps = {
  className: '',
  content: {},
};

export default IconsWithText;
